import { render, staticRenderFns } from "./LectureCategoryTable.vue?vue&type=template&id=347e2c1e&scoped=true&"
import script from "./LectureCategoryTable.vue?vue&type=script&lang=js&"
export * from "./LectureCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./LectureCategoryTable.vue?vue&type=style&index=0&id=347e2c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e2c1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VFlex,VSelect})
